export default "__VITE_ASSET__CbLAnV3g__"